import React, {Component} from "react";
import {Link, Redirect} from 'react-router-dom'
import config from 'react-global-configuration';
import axios from "axios";
import {Button, Input, ModalFooter, ModalHeader} from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import {style} from "variables/Variables.jsx";
import "../assets/css/datatables/datatables.min.css";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import {confirmAlert} from 'react-confirm-alert';
import NotificationSystem from "react-notification-system";
import SimpleReactValidator from 'simple-react-validator';
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import * as moment from "moment";
import DatePicker from "react-datepicker";
import SingUp from '../diyComponents/AddUser';
import jwt_decode from "jwt-decode";
import ModalD from 'react-awesome-modal';


var yesterday = new Date(Date.now() + 360 * 60 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class IntegrationKey extends Component {
    state = {
        users: [],
        newIntegrationModel: false,
        newExtendIntegrationModel: false,
        newIntegrationUserModel: false,
        loading: true,
        organization: '',
        objectType: '',
        key_days: '',
        key_value: '',
        startDate: yestSend,
        userId: '',
        expiryDate: '',
        isIntegrationKeyAccess: false,
        email: '',
        mobile: '',
        logged_user_mail:'',

    };

    componentWillMount() {
        this.validator = new SimpleReactValidator();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        this.setState({
            logged_user_mail: decoded.email
        })

    }

    componentDidMount() {
        this.getIntegrationKeyPermission();
        this._refreshUsers();
    }

    _refreshUsers() {
        // if ($.fn.DataTable.isDataTable('#userTable')) {
        //     $('#userTable').DataTable().destroy();
        // }
        axios.get(config.get('API_URL') + '/users/allusersbytype?user_type=2', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            this.setState({
                users: response.data
            });
            $('#userTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }


    toggleIntegrationModel(id) {

        this.validator.hideMessages();
        var crypto = require("crypto");
        var RandKey = crypto.randomBytes(20).toString('hex');

        this.setState({
            userId: id,
            key_value: RandKey,
            newIntegrationModel: !this.state.newIntegrationModel,
        })
    }

    refreshRandomKey() {

        var crypto = require("crypto");
        var RandKey = crypto.randomBytes(20).toString('hex');

        this.setState({
            key_value: RandKey,
        })
    }

    toggleExtendIntegrationModel(userID, integrationKey, expiryDate) {

        this.setState({
            userId: userID,
            key_value: integrationKey,
            expiryDate: expiryDate

        })
        this.setState({
            newExtendIntegrationModel: !this.state.newExtendIntegrationModel,
        })
    }

    togglenewIntegrationUserModel() {


        this.setState({
            newIntegrationUserModel: !this.state.newIntegrationUserModel,
        })
    }


    extendItegrationKey() {
        //alert(this.state.userId);

        if (this.state.userId == "") {
            this.props.handleClick("tr", 3, "User id not found");
            return;
        }

        if (this.state.key_value == "") {
            this.props.handleClick("tr", 3, "Integration key not found");
            return;
        }

        axios.post(config.get('API_URL') + '/diyusers/generateintegrationkey', {
                userId: this.state.userId,
                integrationKey: this.state.key_value,
                expiryDate: this.state.startDate,
                updated_by: this.state.logged_user_mail
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                this.props.handleClick("tr", 1, response.data.message);
                this._refreshUsers();
            })
            .catch(err => {
                console.log(err)
            });

        this.setState({
            newExtendIntegrationModel: !this.state.newExtendIntegrationModel,
        });

        //window.location.href = "/admin/IntegrationKey";
    }

    getIntegrationKeyPermission() {
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        if(AllAccessPermissions !== undefined) {
            AllAccessPermissions.map((permissionName, i) => {
                if (permissionName.access_type == 'Action' && permissionName.access_name == 'diy_key_management') {
                    this.state.isIntegrationKeyAccess = true;
                }
            });
        }
    }

    handleFromChange = date => { //alert(date);

        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            startDate: date_filter
        });

    };


    AddIntegrationKey() {
        if (this.state.key_value == "") {
            this.props.handleClick("tr", 3, "Enter integration key.");
            return;
        }

        axios.post(config.get('API_URL') + '/diyusers/generateintegrationkey', {
                userId: this.state.userId,
                integrationKey: this.state.key_value,
                expiryDate: this.state.startDate,
                updated_by: this.state.logged_user_mail
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                this.props.handleClick("tr", 1, response.data.message);
                this._refreshUsers();
            })
            .catch(err => {
                console.log(err)
            });

        this.setState({
            newIntegrationModel: !this.state.newIntegrationModel,
        });

    }

    onChangeEmail(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    onChangeMobile(e) {

        if (isNaN(e.target.value)) {

        } else {
            this.setState({
                mobile: e.target.value
            });
        }


    }


    onSubmitData(e) {
        e.preventDefault();
        if (this.state.email === "") {
            this.props.handleClick("tr", 3, "Enter Email Address.");
            return false;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(this.state.email) === false) {
            this.props.handleClick("tr", 3, "Enter Valid Email Id.");
            return false;
        }

        if (this.state.mobile.length === "") {
            this.props.handleClick("tr", 3, "Enter Mobile Number.");
            return false;
        }

        if (this.state.mobile.length !== 10) {
            this.props.handleClick("tr", 3, "Enter Valid Mobile Number.");
            return false;
        }

        axios.post(config.get('API_URL') + '/users/addUser', {
            email: this.state.email,
            mobile: this.state.mobile,
            password: this.state.mobile,
            firstName: '',
            lastName: '',
            phone: this.state.mobile,
            loginType: 'Standard',
            userGroup: 2,
            userSubGroup: 107,
            extra_data: '{}',
            is_active: 'active',
            contact_title: 'Mr',
            user_type: 2
        })
            .then(response => {

                if (response.data.status == 'Registered!') {
                    this.props.handleClick("tr", 1, "Record has been saved.");
                    this._refreshUsers();
                    this.togglenewIntegrationUserModel();
                } else {
                    this.props.handleClick("tr", 3, response.data);
                }
            });
    }

    render() {


        let users = this.state.users.map((user, index) => {
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{user.first_name} {user.last_name}</td>
                    <td>{user.email}</td>
                    <td>{user.integrationData == null ? '' : user.integrationData.integration_key} </td>
                    <td>{user.integrationData == null ? '' : moment(user.integrationData.expiry_date).format('DD/MM/YYYY')}</td>
                    <td>
                        {
                            this.state.isIntegrationKeyAccess == true ?
                                user.integrationData == null ?
                                    <a href="#" className="addButton marginTop btn-edit" role="button"
                                       onClick={this.toggleIntegrationModel.bind(this, user.user_id)}>
                                        <i className="fa fa-key"></i>
                                        Add Key</a> :


                                    <a href="#" className="addButton marginTop btn-edit" role="button"
                                       onClick={this.toggleExtendIntegrationModel.bind(this, user.user_id, user.integrationData.integration_key, user.integrationData == null ? '' : moment(user.integrationData.expiry_date).format('DD/MM/YYYY'))}><i
                                        className="fa fa-key"></i>Extend Key</a>
                                :
                                ""
                        }

                    </td>
                </tr>
            )
        });
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12  pt-5 ">

                            <div className="card">
                                <div className="header">
                                    <div className="col-md-10 col-xs-6">
                                        <h4 className="title">Users</h4>
                                    </div>
                                    <div className="col-md-2 col-xs-6 addIcon">
                                        {/*<a href="#" className="addButton" role="button"*/}
                                        {/*   onClick={this.togglenewIntegrationUserModel.bind(this)}><span*/}
                                        {/*    className="glyphicon glyphicon-plus" aria-hidden="true"></span> Add User</a>*/}
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="content table-full-width table-responsive mt-0">
                                    <NotificationSystem ref="notificationSystem" style={style}/>
                                    <div className='sweet-loading userFixed'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={20}
                                            color={'#123abc'}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    <table className="table table-striped table-hover" id="userTable">
                                        <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Integration Key</th>
                                            <th>Expiry Date</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {users}
                                        </tbody>
                                    </table>
                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ModalD visible={this.state.newIntegrationUserModel} width="400" height="230">
                    <ModalHeader toggle={this.togglenewIntegrationUserModel.bind(this)}>Enter Details For Add New
                        User</ModalHeader>
                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  diyLogPeddingTop">
                            <label htmlFor="EmailId">Email Id::</label>
                        </div>
                        <div className="col-md-8 p-0">
                            <Input placeholder="your@email.com" name="email" type="email"
                                   className="form-control" value={this.state.email}
                                   onChange={this.onChangeEmail.bind(this)}/>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  diyLogPeddingTop">
                            <label htmlFor="MobileNumber">Mobile Number:</label>
                        </div>
                        <div className="col-md-8 p-0">
                            <Input placeholder="Mobile Number" name="mobile" type="mobile"
                                   className="form-control"
                                   value={this.state.mobile} onChange={this.onChangeMobile.bind(this)}
                                   maxlength="10"/>
                        </div>
                    </div>


                    <div className="clearfix"></div>

                    <ModalFooter>
                        <Button color="primary"
                                onClick={this.onSubmitData.bind(this)}>Save</Button>{' '}

                        <Button color="secondary"
                                onClick={this.togglenewIntegrationUserModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </ModalD>


                <ModalD visible={this.state.newIntegrationModel} width="400" height="250">
                    <ModalHeader toggle={this.toggleIntegrationModel.bind(this)}>Enter Details For New Key</ModalHeader>

                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  diyLogPeddingTop">
                            <label htmlFor="selectDate">Validity Date:</label>
                        </div>
                        <div className="col-md-8 p-0">
                            <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selected={Date.parse(this.state.startDate)}
                                onChange={this.handleFromChange}
                                minDate={new Date()}
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  diyLogPeddingTop">
                            <label htmlFor="key">Integration Key:</label>
                        </div>
                        <div className="col-md-8 p-0">
                            <textarea id="key_value" value={this.state.key_value}
                                      onChange={(e) => {
                                          this.setState({key_value: e.target.value});
                                      }} className="diyTextHeightWeight"/>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="col-md-4  ">

                        </div>
                        <div className="col-md-8 p-0">
                            <a href="#" className="addButton" role="button"
                               onClick={this.refreshRandomKey.bind(this)}><span
                                className="glyphicon glyphicon-refresh" aria-hidden="true"></span> Refresh</a>
                        </div>
                    </div>
                    <br/>

                    <div className="clearfix"></div>

                    <ModalFooter>
                        <Button color="primary"
                                onClick={this.AddIntegrationKey.bind(this)}>Save</Button>{' '}

                        <Button color="secondary"
                                onClick={this.toggleIntegrationModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </ModalD>

                <ModalD visible={this.state.newExtendIntegrationModel} width="400" height="210">
                    <ModalHeader
                        toggle={this.toggleExtendIntegrationModel.bind(this, this.state.userId, this.state.key_value, this.state.expiryDate)}>Enter
                        Details For Extend Key</ModalHeader>

                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  diyLogPeddingTop">
                            <label htmlFor="selectDate">Validity Date:</label>
                        </div>
                        <div className="col-md-8 p-0">
                            <DatePicker
                                dateFormat="dd-MM-yyyy"
                                selected={Date.parse(this.state.startDate)}
                                onChange={this.handleFromChange}
                                minDate={new Date()}
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <br/>
                        <div className="col-md-4  ">
                            Expiry Date:
                        </div>
                        <div className="col-md-8 p-0">
                            {this.state.expiryDate}
                        </div>
                    </div>

                    <div className="clearfix"></div>

                    <ModalFooter>
                        <Button color="primary"
                                onClick={this.extendItegrationKey.bind(this)}>Save</Button>{' '}

                        <Button color="secondary"
                                onClick={this.toggleExtendIntegrationModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </ModalD>

            </div>
        );
    }
}

export default IntegrationKey;